import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import styled, { css } from 'styled-components';
import { borderRadius, color, reset, spacing, pixelToRem, propsBlocker, marginAttributes, getComponentOverride } from '../../system';
import { fontSize02, fontSize03, fontSize04, fontFamilyRoboto } from '../../tokens';

var getRootStyle = function getRootStyle(_ref) {
  var small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      pressed = _ref.pressed,
      disabled = _ref.disabled,
      underline = _ref.underline;
  var result = {};

  if (small) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            font-size: ", ";\n        "])), result, pixelToRem(fontSize02));
  } else if (medium) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            font-size: ", ";\n        "])), result, pixelToRem(fontSize03));
  } else if (large) {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            font-size: ", ";\n        "])), result, pixelToRem(fontSize04));
  }

  if (pressed) {
    result = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color('primary.dark'));
  }

  if (underline) {
    result = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ", ";\n            text-decoration: underline;\n        "])), result);
  }

  if (disabled) {
    result = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            cursor: not-allowed;\n            &:hover {\n                color: ", ";\n            }\n        "])), result, color('neutral.04'), color('neutral.04'));
  }

  return result;
};

var LinkTagWrapper = function LinkTagWrapper(_ref2) {
  var children = _ref2.children,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  return children(restProps);
};

export var LinkRoot = styled(LinkTagWrapper).withConfig(propsBlocker)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n    font-family: ", ";\n    color: ", ";\n    position: relative;\n    text-decoration: none;\n    letter-spacing: ", ";\n    line-height: ", ";\n    border: 0 none;\n    &:focus {\n        border: 1px solid ", ";\n        border-radius: ", ";\n    }\n    display: inline;\n    cursor: pointer;\n    &:visited {\n        color: ", ";\n    }\n    &:hover {\n        color: ", ";\n    }\n    ", ";\n    ", ";\n    ", ";\n"])), reset, fontFamilyRoboto, color('primary.main'), spacing(0.1), spacing(5), color('primary.main'), borderRadius('01'), color('purple.05'), color('primary.light'), getRootStyle, marginAttributes, getComponentOverride('Link'));